import { render } from "./BlogPage.vue?vue&type=template&id=c9920dca&scoped=true"
const script = {}

import "./BlogPage.vue?vue&type=style&index=0&id=c9920dca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9920dca"]])

export default __exports__